// The soft olive wash behind the top of the onboarding flow. Shared by the
// steps and the loaders between them so the backdrop never changes as the
// flow moves forward.
//
// Positioned absolutely, so the host's root needs `relative` (or to be fixed
// / absolutely positioned itself) and its content needs to sit above this in
// the stacking order.

export function OnboardingGlow({ className = "" }) {
  return (
    <div
      aria-hidden
      className={`pointer-events-none absolute inset-x-0 top-0 h-[420px] ${className}`}
      style={{
        background:
          "radial-gradient(ellipse 70% 60% at 50% 0%, rgba(77,124,15,0.08), transparent 70%)",
      }}
    />
  );
}

export default OnboardingGlow;
